import ReactGA from "react-ga4";
import { getLocalStorageItem } from "./storageHelper";
import { USER_PROFILE_DATA } from "../api/url";
// import mixpanel from "mixpanel-browser";
import { Analytics } from "../constants";
var useAnalyticsEventTracker = function () {
    var _category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Default Category";
    var profile = getLocalStorageItem(USER_PROFILE_DATA);
    var eventTracker = function () {
        var _profile$data, _profile$data2, _profile$data3, _profile$data4, _profile$data5, _profile$data6;
        var _action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Default Action";
        var _label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Default Label";
        var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        var nonInteraction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (typeof ReactGA.event !== "function") {
            console.error("ReactGA is not initialized. Call ReactGA.initialize() first.");
            return;
        }
        var category = "".concat(_category) + " Name : ".concat(profile === null || profile === void 0 || (_profile$data = profile.data) === null || _profile$data === void 0 ? void 0 : _profile$data.GivenName) + " ".concat(profile === null || profile === void 0 || (_profile$data2 = profile.data) === null || _profile$data2 === void 0 ? void 0 : _profile$data2.FamilyName);
        var action = "".concat(_action) + " Name : ".concat(profile === null || profile === void 0 || (_profile$data3 = profile.data) === null || _profile$data3 === void 0 ? void 0 : _profile$data3.GivenName) + " ".concat(profile === null || profile === void 0 || (_profile$data4 = profile.data) === null || _profile$data4 === void 0 ? void 0 : _profile$data4.FamilyName);
        var label = "".concat(_label) + " Name : ".concat(profile === null || profile === void 0 || (_profile$data5 = profile.data) === null || _profile$data5 === void 0 ? void 0 : _profile$data5.GivenName) + " ".concat(profile === null || profile === void 0 || (_profile$data6 = profile.data) === null || _profile$data6 === void 0 ? void 0 : _profile$data6.FamilyName);
        // console.log("ReactGA", category,
        //     action,
        //     label,
        //     value,
        //     nonInteraction,);
        if (Analytics.MixPanel) {
            // mixpanel.track(`${_action}` + ` ${_label}` + ` Name : ${profile?.data?.GivenName}` + ` ${profile?.data?.FamilyName}`, {
            //     'id': profile?.data?.IdentityId,          // Transaction ID.
            //     'date': `${new Date()}`,
            //     'path': `${window.location.href}`,
            //     'name': `${profile?.data?.GivenName}` + ` ${profile?.data?.FamilyName}`,
            //     'label': _label,
            //     'component': _category
            // });
        }
        if (Analytics.GA) {
            ReactGA.event({
                category: category,
                action: action,
                label: label,
                value: value || undefined,
                // Convert null to undefined if required
                nonInteraction: nonInteraction
            });
        }
    };
    return eventTracker;
};
export default useAnalyticsEventTracker;
